import React from "react";
import "./KSLoading.css";

/**
 * KSLoading - Sleek top animated gradient progress bar for KnightSteps
 *
 * Props:
 * - fixed: boolean (default true) - If true, pins to absolute top of viewport with maximum z-index
 * - height: string (default "3.5px") - Height of the progress line
 * - className: string - Optional custom class name
 * - style: object - Optional custom style overrides
 */
const KSLoading = ({ fixed = true, height = "3.5px", className = "", style = {} }) => {
  return (
    <div
      className={`ks-loading-bar ${fixed ? "ks-loading-fixed" : "ks-loading-inline"} ${className}`}
      style={{ height, ...style }}
      role="progressbar"
      aria-label="Loading..."
    />
  );
};

export default KSLoading;
